/* tslint:disable */
/* eslint-disable */
/**
 * Brandside Backend API
 * REST API бэкенда Brandside. Авторизация — Bearer-токен Laravel Passport (заголовок Authorization: Bearer token). Успешные ответы оборачиваются в конверт success_response — status: true, data: ...; ошибки — common_error_response — status: false, errors._common: сообщение.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime'
/**
 *
 * @export
 * @interface ForgetPasswordRequest
 */
export interface ForgetPasswordRequest {
  /**
   * Существующий email пользователя (валидация rfc/dns + наличие в системе)
   * @type {string}
   * @memberof ForgetPasswordRequest
   */
  email: string
}

/**
 * Check if a given object implements the ForgetPasswordRequest interface.
 */
export function instanceOfForgetPasswordRequest(
  value: object
): value is ForgetPasswordRequest {
  if (!('email' in value) || value['email'] === undefined) return false
  return true
}

export function ForgetPasswordRequestFromJSON(
  json: any
): ForgetPasswordRequest {
  return ForgetPasswordRequestFromJSONTyped(json, false)
}

export function ForgetPasswordRequestFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): ForgetPasswordRequest {
  if (json == null) {
    return json
  }
  return {
    email: json['email'],
  }
}

export function ForgetPasswordRequestToJSON(
  value?: ForgetPasswordRequest | null
): any {
  if (value == null) {
    return value
  }
  return {
    email: value['email'],
  }
}
